import type { AvatarSummary } from "./api.ts";
import { TOOL_LABEL } from "./toolLabels.ts";
import { Badge } from "@/components/ui/badge.tsx";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog.tsx";

/** What an avatar is and can do, on demand rather than always on screen. */
export function AvatarDetail({ avatar, onClose }: { avatar: AvatarSummary; onClose: () => void }) {
  return (
    <Dialog open onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>{avatar.name}</DialogTitle>
          <DialogDescription>{avatar.role}</DialogDescription>
        </DialogHeader>
        <p className="text-sm text-pretty">{avatar.responsibility || "No responsibility has been added for this employee."}</p>
        <div className="grid gap-2">
        <h3 className="text-sm font-medium">Tools and capabilities</h3>
        {avatar.capabilities.length === 0 && <p className="text-sm text-muted-foreground">No capabilities are listed for this employee.</p>}
        <div className="flex flex-wrap gap-1.5">
          {avatar.capabilities.map((c) => (
            <Badge key={c} variant="outline">
              {TOOL_LABEL[c] ?? c}
            </Badge>
          ))}
        </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
